import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../assets/styles/NotFound.css';

// Catch-all for unknown routes (see the path="*" route in routes.js); without it
// a mistyped URL renders a blank page.
const NotFound = () => {
  const { pathname } = useLocation();

  return (
    <main className="ft-not-found">
      <h1 className="ft-not-found__title">Page not found</h1>
      <p className="ft-not-found__message">
        There is nothing at <code>{pathname}</code>.
      </p>
      <Link className="ft-not-found__link" to="/">Back to home</Link>
    </main>
  );
};

export default NotFound;
